window.addEventListener('load', function(event) {

    // Get the email input element by its unique ID

    var emailInput = document.getElementById('email_016JB91TTR00000000003RNEAW');



    // Get the button by its class (as it doesn't have an ID)

    var subscribeButton = document.querySelector('button.go3128815122'); // Use the unique class to target the button



    if (subscribeButton && emailInput) {

        subscribeButton.addEventListener('click', function() {

            // Get the email value from the input field

            var email = emailInput ? emailInput.value : '';

            var emailRegex = /^[^\s@]+@[^\s@]+$/; // Simple email validation regex



            // Validate the email input

            if (emailRegex.test(email)) {

                // Create the custom event data with timestamp, button ID, and email

                var event_data = {

                    timestamp: new Date().toISOString(),

                    buttonId: 'subscribeButton_go3128815122', // Use the class or any unique identifier

                    email: email

                };



                // Publish the custom event to Shopify analytics

                Shopify.analytics.publish('subscription', event_data);

                console.log("Subscription event published to Shopify analytics:", event_data);

            } else {

                console.log("Invalid email address");

            }

        });

    } else {

        console.log("Subscribe button or email input not found on this page");

    }

});